import { render, staticRenderFns } from "./B2CargoProductStatus.vue?vue&type=template&id=37bad78e"
import script from "./B2CargoProductStatus.vue?vue&type=script&lang=js"
export * from "./B2CargoProductStatus.vue?vue&type=script&lang=js"
import style0 from "./B2CargoProductStatus.vue?vue&type=style&index=0&id=37bad78e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports